//mui
import { TextField, InputAdornment, styled } from "@mui/material";

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  marginBottom: theme.spacing(1.5),
  "& label": {
    textTransform: "capitalize",
  },
}));

const IconAdornment = styled(InputAdornment)(({ theme }) => ({
  marginRight: theme.spacing(1),
  "& svg": {
    width: 20,
  },
}));

export const ThemeTextField = ({
  name = "",
  label = "",
  validationRules = {},
  register = () => {},
  errors = {},
  startIcon = null,
  endIcon = null,
  ...rest
}) => {
  const classes = {};

  return (
    <StyledTextField
      label={label}
      {...register(name, validationRules)}
      error={!!errors[name]}
      helperText={errors[name]?.message}
      size="small"
      fullWidth
      variant="outlined"
      data-cy={name}
      InputProps={{
        ...(startIcon && {
          startAdornment: (
            <IconAdornment position="start" className={classes.iconAdornment}>
              {startIcon}
            </IconAdornment>
          ),
        }),
        ...(endIcon && {
          endAdornment: (
            <IconAdornment position="end" className={classes.iconAdornment}>
              {endIcon}
            </IconAdornment>
          ),
        }),
      }}
      {...rest}
    />
  );
};
